/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://ktbva5mtjjhejnw4rnakwnmhqa.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-xrf5zagl4bhjzfch4lodcts3va",
    "aws_cognito_identity_pool_id": "us-east-2:0316311c-9a16-4f75-96d5-b97917778984",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_MhWvbKK5y",
    "aws_user_pools_web_client_id": "6s0c3f0eiaas71mb7gpf5ofmgk",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
